import { atom } from 'jotai';

export const listIsClosedManuallyAtom = atom<boolean>(false);
